import { useQuery } from "@apollo/client/react";
import { SystemConfigDocument } from "../../../generated/graphql";

export function DefaultSettingsDisplay() {
  const { data, loading: isLoading, error } = useQuery(SystemConfigDocument);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-gray-500">Loading default values...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-red-500">Error loading default values: {error.message}</div>
      </div>
    );
  }

  if (!data?.systemConfig?.defaultFSRSSettings) {
    return (
      <div className="flex items-center justify-center py-8">
        <div className="text-gray-500">No default settings found</div>
      </div>
    );
  }

  const settings = data.systemConfig.defaultFSRSSettings;

  return (
    <div className="panel p-6">
      <h4 className="h6 mb-4">Current Default Values</h4>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        <div>
          <dt className="caption mb-1">Max New Cards/Session</dt>
          <dd className="text-sm text-secondary-200">{settings.maxNewCardsPerSession}</dd>
        </div>

        <div>
          <dt className="caption mb-1">Max Reviews/Session</dt>
          <dd className="text-sm text-secondary-200">{settings.maxReviewsPerSession}</dd>
        </div>

        <div>
          <dt className="caption mb-1">Max Attempts/Card</dt>
          <dd className="text-sm text-secondary-200">{settings.maxAttemptsPerCard}</dd>
        </div>

        <div>
          <dt className="caption mb-1">Max Session Duration</dt>
          <dd className="text-sm text-secondary-200">{settings.maxSessionDuration} min</dd>
        </div>

        <div>
          <dt className="caption mb-1">Min New Cards %</dt>
          <dd className="text-sm text-secondary-200">{settings.minNewCardsPercentage}%</dd>
        </div>

        <div>
          <dt className="caption mb-1">Max Cards/Lesson</dt>
          <dd className="text-sm text-secondary-200">{settings.maxCardsPerLesson}</dd>
        </div>

        <div>
          <dt className="caption mb-1">Leech Threshold</dt>
          <dd className="text-sm text-secondary-200">{settings.leechThreshold}</dd>
        </div>

        <div>
          <dt className="caption mb-1">Notification Time</dt>
          <dd className="text-sm text-secondary-200">
            {settings.defaultNotificationTime || "Not set"}
          </dd>
        </div>

        <div>
          <dt className="caption mb-1">Streak Reminders</dt>
          <dd className="text-sm text-secondary-200">
            {settings.streakRemindersEnabled ? (
              <span className="text-success-500 font-medium">Enabled</span>
            ) : (
              <span className="text-gray-600">Disabled</span>
            )}
          </dd>
        </div>
      </div>
    </div>
  );
}
